import { render, staticRenderFns } from "./pantalla7-1movil.vue?vue&type=template&id=91666492&scoped=true&"
var script = {}
import style0 from "./pantalla7-1movil.vue?vue&type=style&index=0&id=91666492&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91666492",
  null
  
)

export default component.exports